import * as types from 'src/store/types';
export default {
  updateAvailableBrands (state, data) {
    state.available = data

    // Проверяем если указано текущей бренд, но он не доступен, то производим сброс
    if (state.current !== null && !data.find(o => o.id === state.current)) {
      this.commit('resetCurrent')
    }
    if (state.current === null && state.available.length > 0) {
      state.current = state.available[0].id
      this.dispatch('events/update', null, {root: true})
    }
  },
  changeCurrent (state, data) {
    state.current = data
    sessionStorage.setItem('current_brand', data)
  },
  resetCurrent (state) {
    state.current = null
    sessionStorage.removeItem('current_brand')
  }
  // update(state) {
  //   debugger
  // }
};
